import { useQuery } from "@tanstack/react-query";
import { documentsAPI } from "../documentsAPI.ts";

export const useGetDocumentsQuery = () => {
  return useQuery ({
    queryKey: ["documents"],
    queryFn: () => documentsAPI.getDocuments(),
    staleTime: 10 * 60 * 1000, // 10мин
    gcTime: 20 * 60 * 1000, // 20мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
